module.exports = __webpack_public_path__ + "img/infrastructure-16.235058a9.png";